/**
 * `kind: SINGLE_SELECT` — one of the question's options.
 *
 * The canvas produces this from `questionType: LIST_SELECTION` with `multiSelect` false, and
 * the only field it edits is the option list, so this control has nothing to configure beyond
 * rendering it.
 */
import { RadioGroup } from '@amzn/awsui-components-react';

import type { DocOption } from '../../utils/wire';
import type { AnswerControlProps } from '../answerTypes';

export interface SingleSelectAnswerProps extends AnswerControlProps {
  options: DocOption[];
}

export default function SingleSelectAnswer({
  options,
  value,
  onChange,
  readOnly,
}: SingleSelectAnswerProps) {
  return (
    <RadioGroup
      // Vertical, which is the Cloudscape default and what the design shows. `direction` is a
      // first-class prop here -- an earlier attempt in this project to force a row with a CSS
      // selector on the generated class name matched nothing and only wrapped the labels.
      value={typeof value === 'string' ? value : null}
      readOnly={readOnly}
      onChange={({ detail }) => onChange(detail.value)}
      items={options.map((o) => ({
        value: o.optionValue,
        // The label carries no identifier any more: the leading "a) " was stripped on
        // migration because `optionValue` is the only id. Showing the letter again here
        // would recreate exactly the drift that made Q1.1.3.1's two sibling questions
        // validate by different keys.
        label: o.label.en,
        description: o.label.zh,
      }))}
    />
  );
}
